import {useContext} from 'react'

import ConfirmContext from 'contexts/ConfirmContext'

const useConfirm = () => useContext(ConfirmContext)

export default useConfirm
